// Tiny corner badge — always visible — showing the commit hash and build
// time of the running bundle. Kills the "is the new code live?" guessing
// game forever. Hover for the full timestamp.
//
// Wired in TWO places on purpose:
//   - main.tsx so it shows on every authenticated page
//   - App.tsx boot shells (LoadingShell / RetryShell / ErrorShell) so it's
//     still visible even when the app fails to start
//
// Build-time constants are injected by vite.config.ts.

export default function BuildBadge() {
  return (
    <div
      title={`Build ${__APP_COMMIT__} · ${__APP_BUILT_AT__}`}
      style={{
        position: 'fixed', bottom: 4, right: 6, zIndex: 100,
        fontSize: 9, color: 'rgba(0,0,0,0.35)', fontFamily: 'monospace',
        pointerEvents: 'none', userSelect: 'none',
      }}
    >
      {__APP_COMMIT__}
    </div>
  )
}
